export const shouldFlip = (theme) => theme.direction === 'rtl'
